import './style.css';
import IMAGEM from '../imagem';

function Cupom(props) {
  return (
    <div className="cupom" key={props.idCupom}>
      <div className="cupom-images">
        <IMAGEM src={props.banner} className="banner-image" />
        <div className="logo-container">
          <IMAGEM src={props.logo} className="logo-image" />
        </div>
      </div>
      <div className="cupom-content">
        <h4 className="cupom-estab">{props.nom_estabelecimento}</h4>
        <h4 className="cupom-title">{props.den_campanha}</h4>
        
        <div className="cupom-footer">
          <p className="cupom-subtitle">{`Cód: ${props.idCupom}`}</p>
          <span className="cupom-badge">Sorteio</span>
        </div>
      </div>
    </div>
  );
}

export default Cupom;